import { API_BASE, apiFetch } from "../../api/http";

export async function postScorecard(body: { docContent: string; jurisdiction?: string; docType?: "protocol" | "protective"; weightBoost?: Record<string, boolean>; selectedQuestions?: Array<{ sectionId: string; question: string }> }): Promise<any> {
  const res = await apiFetch(`${API_BASE}/api/analysis/scorecard`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`analysis/scorecard failed: ${res.status}`);
  return res.json();
}


